const projectPage = {
  "byb360.page.matches.title": "Matches",
  "byb360.page.match.title": "Match",
  "byb360.matches.empty": "No matches found",
  "byb360.matches.import": "Import",
  "byb360.matches.draw": "Draw",
  "byb360.matches.won": "Won",
  "byb360.matches.lost": "Lost",
  "byb360.matches.week": "Week",

  // Projects Index
  "byb360.project.edit.project": "Edit Project",
  "byb360.project.create.project": "Create Project",
  "byb360.project.name": "Project Name",
  "byb360.project.add.project.name": "Enter project name",
  "byb360.project.source": "Source",
  "byb360.project.choose.source": "Choose source",
  "byb360.project.local.file": "Local file",
  "byb360.project.cloud.match": "Cloud match",
  "byb360.project.description": "Description",
  "byb360.project.empty": "Optional description",
  "byb360.project.comment": "Comment",
  "byb360.project.archive.project": "Archive project",
  "byb360.project.preparing.project": "Preparing project...",
  "byb360.project.upload.files": "Upload Files",
  "byb360.project.add.files": "Add {{files}} files to import your project data.",
  "byb360.project.selected.files": "Selected files ({{files}})",
  "byb360.project.detecting.format": "Detecting format",
  "byb360.project.complete": "Complete",
  "byb360.project.error": "Error",
  "byb360.project.processing": "Processing...",
  "byb360.project.preparing": "Preparing...",
  "byb360.project.upload": "Upload",
  "byb360.project.data": "data",
  "byb360.project.and": "and",
  "byb360.project.import.project.data": "Import project data",
  "byb360.project.choose.match.data": "Choose match data",
  "byb360.project.project.name": "Project Name",
  "byb360.project.created": "Created",
  "byb360.project.actions": "Actions",
  "byb360.project.delete.project": "Delete Project",
  "byb360.project.delete.confirmation": "Are you sure you want to delete the following project?",
  "byb360.project.delete.warning": "This action cannot be undone. All associated tracking data and folders will also be deleted.",
  "byb360.project.deleting": "Deleting...",
  "byb360.project.clear.local.data": "Clear Local Tracking Data",
  "byb360.project.reprocess.data": "Reprocess Tracking Data",
  "byb360.project.reprocessing": "Reprocessing...",
  "byb360.project.default.folder.name": "My Clips",
  "byb360.project.search.placeholder": "Search projects...",

  // Clip Context
  "byb360.clip.context.default.name": "New Clip",
  "byb360.clip.context.title": "Timeline Clip",
  "byb360.clip.context.save": "Save",
  "byb360.clip.context.download": "Download",
  "byb360.clip.context.name": "Name",
  "byb360.clip.context.folder": "Folder",
  "byb360.clip.context.select.folder": "Select a folder",
  "byb360.clip.context.status": "Status",
  "byb360.clip.context.status.published": "Published",
  "byb360.clip.context.status.generated": "Generated",
  "byb360.clip.context.status.selected": "Selected",
  "byb360.clip.context.start.end": "Start / End",
  "byb360.clip.context.duration": "Duration",
  "byb360.clip.context.player": "Player",
  "byb360.clip.context.generate.clip.to.select.player": "Generate clip to select player",
  "byb360.clip.context.set.player": "Set Player",
  "byb360.clip.context.note": "Note",
  "byb360.clip.context.enter.clip.name": "Enter clip name...",
  "byb360.clip.context.enter.note": "Enter note...",
  "byb360.clip.context.select.player": "Select a player",
  "byb360.clip.context.loading.players": "Loading players...",
  "byb360.clip.context.ball.behaviour": "Ball Behaviour",
  "byb360.clip.context.ball.behaviour.tracking": "Follow Tracking",
  "byb360.clip.context.ball.behaviour.actions": "Use Actions",

  // Folder Context
  "byb360.folder.context.enter.folder.name": "Enter folder name",
  "byb360.folder.context.clips": "Saved clips",
  "byb360.folder.context.no.clips": "No clips yet",
  "byb360.folder.context.projects": "Projects",
  "byb360.folder.context.no.projects": "No projects",
  "byb360.folder.context.add.to.playlist": "Add to playlist",
  "byb360.folder.context.update": "Update",
  "byb360.folder.context.delete.confirmation": "Are you sure you want to delete this folder?",
  "byb360.folder.context.period.1.offset": "P1 Offset",
  "byb360.folder.context.period.2.offset": "P2 Offset",

  // Folder Explorer
  "byb360.folder.explorer.folders": "Folders",
  "byb360.folder.explorer.no.folders": "No folders yet",
  "byb360.folder.explorer.create.first.folder": "Create your first folder to organize your scenarios",
  "byb360.folder.explorer.shared.folders": "Shared Folders",
  "byb360.folder.explorer.no.shared.folders": "There are no folders shared between {{ projects }}",
  "byb360.folder.create.error.title": "Failed to create folder",
  "byb360.folder.create.error.subtitle": "Please try again or contact support",

  // Empty Context
  "byb360.empty.context.no.selection": "No Selection",
  "byb360.empty.context.select.folder.or.timeline":
    "Select a folder from the explorer or make a selection in the timeline to see contextual information here.",

  // Context Row
  "byb360.context.row.add.note": "Add a note...",

  // Match Timeline
  "byb360.timeline.search.events": "Search events...",
  "byb360.timeline.search.results": "results",
  "byb360.timeline.generate.clip": "Generate Clip",
  "byb360.timeline.start": "Start:",
  "byb360.timeline.end": "End:",
  "byb360.timeline.duration": "Duration:",

  // Event Offset
  "byb360.timeline.event.offset.title": "Event Timing Offset",
  "byb360.timeline.event.offset.tooltip": "Event Offset: {{offset}}",
  "byb360.timeline.event.offset.description":
    "Offset all events to fix synchronization issues. Use the slider for quick adjustments or input precise values below.",
  "byb360.timeline.event.offset.available.range": "Available range: {{min}} to {{max}}",
  "byb360.timeline.event.offset.no.events": "No events available to offset",
  "byb360.timeline.event.offset.backward": "Backward",
  "byb360.timeline.event.offset.forward": "Forward",
  "byb360.timeline.event.offset.visual.control": "Visual Offset Control",
  "byb360.timeline.event.offset.current": "Current offset: {{offset}}",
  "byb360.timeline.event.offset.minutes": "Minutes",
  "byb360.timeline.event.offset.seconds": "Seconds",
  "byb360.timeline.event.offset.milliseconds": "Milliseconds",
  "byb360.timeline.event.offset.value": "Offset value",
  "byb360.timeline.event.offset.unit.minutes": "min",
  "byb360.timeline.event.offset.unit.seconds": "sec",
  "byb360.timeline.event.offset.unit.milliseconds": "ms",
  "byb360.timeline.event.offset.first.half": "1st Half",
  "byb360.timeline.event.offset.second.half": "2nd Half",
  "byb360.timeline.event.offset.kickoff.time": "2nd Half Kickoff Time",
  "byb360.timeline.event.offset.kickoff.time.description":
    "Set when the second half begins to enable separate event offsets for each half. This value is saved locally in your browser and is required to adjust event timing.",
  "byb360.timeline.event.offset.kickoff.time.required": "2nd half kickoff time is required",
  "byb360.timeline.event.offset.kickoff.time.placeholder": "e.g., 45:30",
  "byb360.timeline.event.offset.warning.no.kickoff":
    "Event offsets are detected for this project, but no kickoff time is set. Please set the 2nd half kickoff time to enable proper event timing adjustments.",
  "byb360.timeline.event.offset.error.title": "Failed to update event offsets",
  "byb360.timeline.event.offset.error.subtitle": "Please try again or contact support if the problem persists",

  // Validation Messages
  "byb360.validation.select.folder": "Please select a folder to save the clip",
  "byb360.validation.generate.clip": "Please generate a clip first by clicking the + button in the timeline",
  "byb360.validation.set.player": 'Please set a player in the scenario builder by double-clicking on a player and selecting "Set Player"',
  "byb360.validation.requirements.before.saving": "Please {{requirements}} before saving",

  // Clip Preview Modal
  "byb360.clip.preview.title": "Clip Preview:",
  "byb360.clip.preview.saved.clip": "Saved Clip",

  // Cascading Submenu
  "byb360.submenu.select.all": "Select All",
  "byb360.submenu.deselect.all": "Deselect All",
  "byb360.submenu.of": "of",
  "byb360.submenu.selected": "selected",
  "byb360.submenu.no.items.available": "No items available",

  // Player selection
  "byb360.player.name.default": "Player {id}",

  // File Import Validation
  "byb360.project.import.warning.multiple.formats": "Multiple data formats detected: {{formats}}. This may cause processing issues.",
  "byb360.project.import.error.requires.single": "This file requires a {{format}} file",
  "byb360.project.import.error.requires.multiple": "This file requires {{formats}} files",
  "byb360.project.import.error.unsupported.format": "Unsupported file format",
  "byb360.project.import.fix.errors": "Please fix all errors before proceeding",

  // Multi-Project Menu
  "byb360.multi-project.no.projects": "No projects selected",
  "byb360.multi-project.tooltip": "Click to switch projects",
  "byb360.multi-project.multiple.tooltip": "Multiple projects selected - click to manage",

  // Multi-Project Selector
  "byb360.multi-project.selector.title": "Project Manager",
  "byb360.multi-project.selector.active": "Active Projects",
  "byb360.multi-project.selector.create.shared.folder": "Create Shared Folder",
  "byb360.multi-project.selector.add": "Add Projects",
  "byb360.multi-project.selector.search": "Search projects...",
  "byb360.multi-project.selector.loading": "Loading projects...",
  "byb360.multi-project.selector.no.results": "No projects found",
  "byb360.multi-project.selector.no.available": "No available projects",
  "byb360.multi-project.selector.remove": "Remove project",

  // Multi-Project Folder Operations
  "byb360.multi-project.folder.created.title": "Shared folder created successfully",
  "byb360.multi-project.folder.created.subtitle": "Clips saved to this folder will be shared between all associated Projects",
  "byb360.multi-project.folder.create.error": "Failed to create shared folder",
  "byb360.multi-project.folder.project.added": "Project added to folder successfully",
  "byb360.multi-project.folder.project.add.error": "Failed to add project to folder",
  "byb360.multi-project.folder.project.removed": "Project removed from folder successfully",
  "byb360.multi-project.folder.project.remove.error": "Failed to remove project from folder",

  // Playlist Dropdown
  "byb360.playlist.dropdown.create.new.playlist": "Create new playlist",
  "byb360.playlist.dropdown.no-playlists-found": "No playlists found",
  "byb360.playlist.dropdown.no-recent-playlists": "No recent playlists",
  "byb360.playlist.dropdown.search.placeholder": "Search playlists...",
  "byb360.playlist.dropdown.error.publish-scenario.title": "Failed to publish scenario",
  "byb360.playlist.dropdown.error.publish-scenario.message": `Failed to publish scenario "{{name}}". You can either try to add them to a playlist again or publish them manually in the Simulation Builder. Otherwise, please contact support.`,
  "byb360.playlist.dropdown.error.update-playlist.title": "Failed to update playlist",
  "byb360.playlist.dropdown.error.update-playlist.message": "Please try again or contact support.",
};

export const byb360 = {
  ...projectPage,
};
